import i18n from "../../src/lang/index.js";

function indexData(index, dayCount) {
  var data = {};
  if (index == 0) {
    //周
    data.xData = [
      i18n.t("machine.record2")[1],
      i18n.t("machine.record2")[2],
      i18n.t("machine.record2")[3],
      i18n.t("machine.record2")[4],
      i18n.t("machine.record2")[5],
      i18n.t("machine.record2")[6],
      i18n.t("machine.record2")[0]
    ];
  } else if (index == 1) {
    //月
    var xData = [];
    for (var i = 1; i <= dayCount; i++) {
      xData.push(i);
    }
    data.xData = xData;
  } else {
    //年
    data.xData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }
  return data;
}

function dayX(list) {
  if (list.length != 0 && list.xvalues.length > 0) {
    return list.xvalues;
  } else {
    return ["00:00"];
  }
}

//范围值颜色
function getColor(normal, color) {
  if (normal == 1) {
    return "#FF0000";
  } else if (normal == 4) {
    return "#FF9D1F";
  } else if (normal == 6) {
    return "#C20000";
  } else if (normal == 7) {
    return "#7F00C1";
  } else if (normal == 2 || normal == 3) {
    return color;
  }
}

//血压心率
export function hrbpOption(index, list) {
  var dayCount = index == 1 ? list.hr.length : 0;
  var option = {
    animation: false,
    color: ["#59A3DC", "#F7AE12", "#0AD280"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 200,
      interval: 50
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.sbpNormal[params.dataIndex], "#59A3DC");
          }
        },
        data: list.sbp
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.dbpNormal[params.dataIndex], "#F7AE12");
          }
        },
        data: list.dbp
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.hrNormal[params.dataIndex], "#0AD280");
          }
        },
        data: list.hr
      }
    ]
  };
  return option;
}

//血脂
export function bloodFatOption(index, list) {
  var dayCount = index == 1 ? list.chol.length : 0;
  var option = {
    animation: false,
    color: ["#01ECC2", "#C66F22", "#DC51ED", "#3970EC"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 12,
      interval: 3
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.cholNormal[params.dataIndex], "#01ECC2");
          }
        },
        data: list.chol
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.tgNormal[params.dataIndex], "#C66F22");
          }
        },
        data: list.tg
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.ldlcNormal[params.dataIndex], "#DC51ED");
          }
        },
        data: list.ldlc
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.hdlcNormal[params.dataIndex], "#3970EC");
          }
        },
        data: list.hdlc
      }
    ]
  };
  return option;
}

//血糖
export function gluOption(index, list) {
  var dayCount = index == 1 ? list.glu_0.length : 0;
  var option = {
    animation: false,
    color: ["#51D9ED", "#5997DC"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 12,
      interval: 3
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.glu0Normal[params.dataIndex], "#51D9ED");
          }
        },
        data: index == 3 ? getGluOption(list.glu_0) : list.glu_0,
        connectNulls: index == 3 ? false : true
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.glu1Normal[params.dataIndex], "#5997DC");
          }
        },
        data: index == 3 ? getGluOption(list.glu_1) : list.glu_1,
        connectNulls: index == 3 ? false : true
      }
    ]
  };
  return option;
}
// 血糖值处理
function getGluOption(value) {
  var arr = [];
  for (var i = 0; i < value.length; i++) {
    if (value[i] <= 0) {
      arr[i] = "";
    } else {
      arr[i] = value[i];
    }
  }
  return arr;
}

//尿酸
export function uricAcidOption(index, list) {
  var dayCount = index == 1 ? list.uricAcid.length : 0;
  var option = {
    animation: false,
    color: ["#3970EC"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 600,
      interval: 150
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.uaNormal[params.dataIndex], "#3970EC");
          }
        },
        data: list.uricAcid
      }
    ]
  };
  return option;
}

// 小白手表
export function sleepOption(list) {
  var option = {
    animation: false,
    series: {
      type: "pie",
      radius: ["60%", "100%"],
      hoverAnimation: false,
      itemStyle: {
        borderRadius: 5,
        borderColor: "#fff",
        borderWidth: 2
      },
      labelLine: {
        show: false
      },
      data: [
        {
          value: list.sleep.deep,
          itemStyle: {
            color: "#9031EF"
          }
        },
        {
          value: list.sleep.light,
          itemStyle: {
            color: "#CD47EE"
          }
        },
        {
          value: list.sleep.rem,
          itemStyle: {
            color: "#FC7B3A"
          }
        },
        {
          value: list.sleep.awake,
          itemStyle: {
            color: "#F3C200"
          }
        }
      ]
    }
  };
  return option;
}

/*
 * JCRing
 * AI图表
 *
 */

// 睡眠柱状图
export function sleepBarEcharts(params) {
  let option = {
    grid: {
      left: 2,
      right: 2,
      bottom: 10,
      top: 25,
      containLabel: true
    },
    tooltip: {
      trigger: "axis",
      showContent: false,
      triggerOn: "click",
      axisPointer: {
        lineStyle: {
          opacity: 0.5,
          width: 0.2,
          type: "solid"
        }
      }
    },
    xAxis: {
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      },
      type: "category",
      data: params ? params.xData : ["1", "2", "3", "4", "5", "6", "7"]
    },
    yAxis: {
      type: "value",
      interval: 20,
      min: params.min ? params.min : 0 , // 设置Y轴起始值为60
      splitLine: {
        lineStyle: {
          color: "#4a4a4a",
          opacity: 0.5
        }
      }
    },
    series: [
      {
        data: params ? params.yData : [],
        label: {
          show: true,
          position: "top", // 显示位置在顶部
          formatter: "{c}", // {c}表示当前数据值
          color: "#fff" // 白色字体
        },
        type: "bar",
        itemStyle: {
          // 通过回调函数设置不同的颜色
          color: function(params) {
            // params是一个包含数据信息的对象
            var colorList = [
              "#ff4569",
              "#ff7839",
              "#ffce3d",
              "#a0ed44",
              "#42eca8"
            ];
            return colorList[params.dataIndex % colorList.length];
          }
        }
      }
    ]
  };
  return option;
}

//周月睡眠概览
export function weekBarEcharts(params) {
  let option = {
    animation: false,
    grid: {
      left: 2,
      right: 2,
      bottom: 10,
      top: 25,
      containLabel: true
    },
    tooltip: {
      show: true,
      trigger: "axis",
      showContent: false,
      triggerOn: "click",
      axisPointer: {
        lineStyle: {
          opacity: 0.5,
          width: 0.2,
          type: "solid"
        }
      }
    },
    xAxis: {
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#DDDDDD",
          width: 1,
          type: "solid"
        }
      },
      data: params.xData
    },
    yAxis: {
      position: "left",

      splitLine: {
        lineStyle: {
          color: "#4a4a4a",
          opacity: 0.5
        }
      }
    },
    series: [
      {
        type: "bar",
        silent: true,
        stack: "Ad",
        itemStyle: {
          color: "#3257b3"
        },

        data: params.deepSleepList
      },
      {
        type: "bar",
        silent: true,
        stack: "Ad",
        itemStyle: {
          color: "#446ac8"
        },
        data: params.lightSleepList
      },
      {
        type: "bar",
        silent: true,
        stack: "Ad",
        itemStyle: {
          color: "#7992c9"
        },
        data: params.remSleepList
      },
      {
        type: "bar",
        silent: true,
        stack: "Ad",
        itemStyle: {
          color: "#a6b2ce"
        },
        data: params.awakeSleepList
      },
      {
        type: "bar",
        silent: true,
        stack: "Ad",
        itemStyle: {
          color: "#c6cacf"
        },
        data: params.napSleepList,
        label: {
          show: true,
          position: "top", // 显示位置在顶部
          formatter: "{c}", // {c}表示当前数据值
          color: "#fff", // 白色字体
          formatter: function(e) {
            return (
              (
                params.napSleepList[e.dataIndex] +
                params.awakeSleepList[e.dataIndex] +
                params.remSleepList[e.dataIndex] +
                params.lightSleepList[e.dataIndex] +
                params.deepSleepList[e.dataIndex]
              ).toFixed(1) + "H"
            );
          }
        }
      }
    ]
  };
  return option;
}

//周月饼状睡眠概览
export function PieEcharts(params) {
  console.log(params, "睡眠");
  let option = {
    grid: {
      left: 2,
      right: 2,
      bottom: 10,
      top: 25,
      containLabel: true
    },
    series: [
      {
        type: "pie",
        radius: "100%",
        data: [
          {
            value: params.avgSleepTimeList,
            name: "	平均时长",
            labelLine: { show: false }
          },
          {
            value: params.avgSleepTimePercentList,
            name: "	平均占比",
            labelLine: { show: false }
          }
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 1,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)"
          }
        }
      }
    ]
  };
  return option;
}
// 柱状折线图
export function BarLineEcharts(params) {
  console.log(params);
  let option = {
    grid: {
      left: 2,
      right: 2,
      bottom: 25,
      top: 25,
      containLabel: true
    },
    tooltip: {
      trigger: "axis",
      showContent: false,
      triggerOn: "click",
      axisPointer: {
        lineStyle: {
          opacity: 0.5,
          width: 0.2,
          type: "solid"
        }
      }
    },
    legend: {
      bottom: 1,
      left: "center",
      data: ["睡眠效率(%)", "入睡用时(min)"],
      itemWidth: 12, // 设置图例标记的图形宽度
      itemHeight: 12, // 设置图例标记的图形高度
      textStyle: {
        color: "#cccccc", // 这里设置图例的字体颜色为红色
        fontSize: 10 // 这里设置图例的字体大小为14
      }
    },
    xAxis: {
      axisTick: {
        // 坐标轴小标记
        show: false
      },

      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      },
      type: "category",
      data: params.xData
    },
    yAxis: [
      {
        name: "%",
        type: "value",
        nameLocation: "start", // 名称显示在开头
        nameTextStyle: {
          verticalAlign: "center" // 文字底部对齐
        },
        interval: 50,
        splitLine: {
          lineStyle: {
            color: "#4a4a4a",
            opacity: 0.5
          }
        }
      },
      {
        name: "min",
        nameLocation: "start", // 名称显示在开头
        nameTextStyle: {
          verticalAlign: "center" // 文字底部对齐
        },
        type: "value",
        min: 0,
        max: 20,
        interval: 10,
        splitLine: {
          lineStyle: {
            color: "#4a4a4a",
            opacity: 0.5
          }
        }
      }
    ],
    series: [
      {
        name: "入睡用时(min)",
        data: params.sleepEfficiencyList,
        type: "bar"
      },
      {
        name: "睡眠效率(%)",
        data: params.fallAsleepList,
        type: "line",
        smooth: false,
        lineStyle: {
          color: "#c8ccd1", // 线条颜色
          width: 2, // 线条宽度
          type: "solid" // 线条类型，默认为实线，可选：'solid', 'dashed', 'dotted'
        }, // 设置折线上圆点的样式
        itemStyle: {
          normal: {
            color: "#c8ccd1", // 圆点颜色
            borderColor: "#c8ccd1", // 圆点边框颜色
            borderWidth: 2 // 圆点边框宽度
          }
        }
      }
    ]
  };
  return option;
}

// 活力与能量消耗柱状图
export function ExpendBarEcharts(params) {
  let option = {
    grid: {
      left: 2,
      right: 2,
      bottom: 10,
      top: 25,
      containLabel: true
    },
    tooltip: {
      trigger: "axis",
      showContent: false,
      triggerOn: "click",
      axisPointer: {
        lineStyle: {
          opacity: 0.5,
          width: 0.2,
          type: "solid"
        }
      }
    },
    xAxis: {
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      },
      type: "category",
      data: params.xData
    },
    yAxis: {
      type: "value",
      interval: 20,
      min: 0, // 设置Y轴起始值为60
      splitLine: {
        lineStyle: {
          color: "#4a4a4a",
          opacity: 0.5
        }
      }
    },
    series: [
      {
        data: params.yData,
        label: {
          show: true,
          position: "top", // 显示位置在顶部
          formatter: "{c}", // {c}表示当前数据值
          color: "#fff" // 白色字体
        },
        type: "bar",
        itemStyle: {
          // 通过回调函数设置不同的颜色
          color: function(params) {
            // params是一个包含数据信息的对象
            var colorList = [
              "#ff4569",
              "#ff7839",
              "#ffce3d",
              "#a0ed44",
              "#42eca8"
            ];
            return colorList[params.dataIndex % colorList.length];
          }
        }
      }
    ]
  };
  return option;
}

// 活力与能量消耗柱概览线性图
export function ExpendLineEcharts(params) {
  let option = {
    grid: {
      left: 5,
      right: 5,
      bottom: 30,
      top: 25,
      containLabel: true
    },
    legend: {
      bottom: 1,
      left: "center",
      data: ["步数", "卡路里", "距离"],
      itemWidth: 12, // 设置图例标记的图形宽度
      itemHeight: 12, // 设置图例标记的图形高度
      textStyle: {
        color: "#cccccc", // 这里设置图例的字体颜色为红色
        fontSize: 10 // 这里设置图例的字体大小为14
      }
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: params.xData,
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      }
    },
    yAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          color: "#4a4a4a",
          opacity: 0.5
        }
      }
    },
    series: [
      {
        name: "步数",
        type: "line",
        stack: "Total",
        data: params.stepList,
        color: "#FCDC55"
      },
      {
        name: "卡路里",
        type: "line",
        stack: "Total",
        data: params.calorieList,
        color: "#FC9055"
      },
      {
        name: "距离",
        type: "line",
        stack: "Total",
        data: params.distanceList,
        color: "#FC5555"
      }
    ]
  };
  return option;
}

// 压力
export function PressureEcharts(params) {
  let option = {
    grid: {
      left: 5,
      right: 5,
      bottom: 30,
      top: 25,
      containLabel: true
    },
    legend: {
      bottom: 1,
      left: "center",
      data: ["压力", "应激反应", "恢复指数"],
      itemWidth: 12, // 设置图例标记的图形宽度
      itemHeight: 12, // 设置图例标记的图形高度
      textStyle: {
        color: "#cccccc", // 这里设置图例的字体颜色为红色
        fontSize: 10 // 这里设置图例的字体大小为14
      }
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: params.xData,
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      }
    },
    yAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          color: "#4a4a4a",
          opacity: 0.5
        }
      }
    },
    series: [
      {
        name: "压力",
        type: "line",
        stack: "Total",
        data: params.stepList,
        color: "#FCDC55"
      },
      {
        name: "应激反应",
        type: "line",
        stack: "Total",
        data: params.calorieList,
        color: "#FC9055"
      },
      {
        name: "恢复指数",
        type: "line",
        stack: "Total",
        data: params.distanceList,
        color: "#FC5555"
      }
    ]
  };
  return option;
}
// 心率线性图
export function heartRateEcharts(params) {
  let option = {
    grid: {
      left: 2,
      right: 2,
      bottom: 10,
      top: 25,
      containLabel: true
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: params.xData,
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      }
    },
    yAxis: {
      type: "value",
      min: params.min ? params.min : 0 , // 设置Y轴起始值为60
      splitLine: {
        lineStyle: {
          color: "#4a4a4a",
          opacity: 0.5
        }
      }
    },
    series: [
      {
        type: "line",
        stack: "Total",
        data: params.yData,
        color: "#FC5555",
        label: {
          show: true,
          color:'#f6f6f6'
      }
      }
    ]
  };
  return option;
}
// 血氧线性图
export function bloodOxygenDataEcharts(params) {
  console.log(params, "bloodOxygenDataEcharts");
  let option = {
    grid: {
      left: 2,
      right: 2,
      bottom: 10,
      top: 25,
      containLabel: true
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: params.xData,
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      }
    },
    yAxis: {
      type: "value",
      min: params.min ? params.min : 0 , // 设置Y轴起始值为60
      splitLine: {
        lineStyle: {
          color: "#4a4a4a",
          opacity: 0.5
        }
      }
    },
    series: [
      {
        type: "line",
        stack: "Total",
        data: params.yData,
        color: "#FC5555",
        label: {
          show: true,
          color:'#f6f6f6'
      }
      }
    ]
  };
  return option;
}

// 柱状图
export function BarEcharts(params) {
  let option = {
    grid: {
      left: 0,
      right: 0,
      bottom: 25,
      top: 25,
      containLabel: true
    },
    tooltip: {
      trigger: "axis",
      showContent: false,
      triggerOn: "click",
      axisPointer: {
        lineStyle: {
          opacity: 0.5,
          width: 0.2,
          type: "solid"
        }
      }
    },
    xAxis: {
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#6e7079" // 这里设置x轴刻度的字体颜色
        }
      },
      axisLine: {
        // 坐标轴线
        show: false, // 默认显示，属性show控制显示与否
        lineStyle: {
          // 属性lineStyle控制线条样式
          color: "#4a4a4a",
          width: 1,
          type: "solid"
        }
      },
      type: "category",
      data:params.xData
    },
    yAxis: [
      {
        type: "value",
        nameLocation: "start", // 名称显示在开头
        nameTextStyle: {
          verticalAlign: "center" // 文字底部对齐
        },
        splitLine: {
          lineStyle: {
            color: "#4a4a4a",
            opacity: 0.5
          }
        }
      },
     
    ],
    series: [
      {
        data: params.yData,
        type: "bar",
        label: {
        position:'top',
          show: true,
          color:'#f6f6f6'
      }
      }
    ]
  };
  return option;
}



//////////////////
// WEBPACK FOOTER
// ./static/js/echarts.js
// module id = null
// module chunks = 